var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMageEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9088 12.0341V15.7341C15.9086 16.2576 15.7006 16.7596 15.3304 17.1298C14.9602 17.5 14.4582 17.708 13.9347 17.7083H4.26717C4.00697 17.7082 3.74935 17.6566 3.50912 17.5567C3.26889 17.4567 3.05078 17.3102 2.86733 17.1257C2.68388 16.9411 2.5387 16.7222 2.44014 16.4814C2.34158 16.2405 2.29158 15.9826 2.293 15.7224V6.06576C2.29146 5.80597 2.34148 5.54845 2.44019 5.30814C2.53889 5.06782 2.68431 4.84948 2.86802 4.66578C3.05172 4.48207 3.27006 4.33665 3.51038 4.23795C3.75069 4.13924 4.00821 4.08922 4.268 4.09076H7.96717",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9098 7.49576L12.5056 4.09076M5.69727 13.1691V11.3649C5.69893 11.0674 5.81727 10.7816 6.02643 10.5708L13.9698 2.62743C14.0752 2.52085 14.2007 2.43624 14.339 2.3785C14.4773 2.32075 14.6257 2.29102 14.7756 2.29102C14.9255 2.29102 15.0739 2.32075 15.2122 2.3785C15.3505 2.43624 15.476 2.52085 15.5814 2.62743L17.3739 4.41993C17.4805 4.52533 17.5651 4.65082 17.6229 4.78915C17.6806 4.92747 17.7104 5.07587 17.7104 5.22576C17.7104 5.37566 17.6806 5.52406 17.6229 5.66238C17.5651 5.80071 17.4805 5.9262 17.3739 6.0316L9.4306 13.9749C9.21938 14.1847 8.93411 14.3029 8.63643 14.3041H6.83227C6.68315 14.3043 6.53547 14.2751 6.39766 14.2181C6.25986 14.1612 6.13465 14.0776 6.02921 13.9722C5.92377 13.8667 5.84018 13.7415 5.78322 13.6037C5.72626 13.4659 5.69705 13.3182 5.69727 13.1691Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMageEdit);
export default __webpack_public_path__ + "static/media/mage_edit.ee88fb87f4e9bf2e54e97aae268806fc.svg";
export { ForwardRef as ReactComponent };